<div class="row">
  <div class="col-12">
    <nb-card accent="primary">
      <nb-card-header>
        {{ "welcome_title" | translate }}
      </nb-card-header>

      <nb-card-body *ngIf="$clientId | async">
        {{ "welcome_text" | translate }}
      </nb-card-body>

      <nb-card-body *ngIf="!($clientId | async)">
        <ng-container *ngIf="currentLanguageCode == 'de'">
          <p>Schön, dass Sie sich bei uns registriert hasben.</p>
          <p>
            Einer unserer Mitarbeiter (Projektmanager oder Vertriebsmitarbeiter)
            wird sich bei Ihnen melden, um Ihre Bedürfnisse zu besprechen, bevor
            wir Ihr Konto aktivieren. Der Prozess kann einen Moment dauern, wir
            bitten um etwas Geduld. Sobald Ihr Konto bereit ist, können Sie
            sofort mit der Erstellung Ihrer ersten App beginnen.
          </p>
          <p>
            Solltest Sie bereits wissen, wie Sie unseren Service nutzen wollen
            und benötigen ein anderes Paket, bzw. eine detaillierte Beratung zu
            unseren Leistungen, melden Sie sich gerne direkt bei uns.
          </p>
          <p>
            <span>Kontaktieren Sie uns:</span>
            <br />
            <span>Mail: </span>
            <a
              href="mailto:push@ethinking.de?subject=Question%20from%20ethinking.push"
              >push@ethinking.de</a
            >
            <br />
            <span>Web: </span>
            <a href="https://ethinking.de/push" target="_blank" rel="noopener"
              >https://ethinking.de/push</a
            >
          </p>
          <p>
            In der Zwischenzeit können Sie gerne unsere
            <a href="" target="_blank" rel="noopener noreferrer"
              >Dokumentation
            </a>
            [link →TBD] erkunden.
          </p>
        </ng-container>

        <ng-container *ngIf="currentLanguageCode == 'en'">
          <p>Thank you for registering to our service.</p>
          <p>
            One of our team members (a project manager or sales representative)
            will reach out to discuss your needs before activating your account.
            The process may take a moment, so we appreciate your patience. Once
            your account is ready, you can start creating your first app right
            away.
          </p>
          <p>
            If you already know how you'd like to use ethinking.push and need an
            extended package, or if you require support or consultation, our
            Customer Success Team is here to help.
          </p>
          <p>
            <span>Contact us:</span>
            <br />
            <span>Mail: </span>
            <a
              href="mailto:push@ethinking.de?subject=Question%20from%20ethinking.push"
              >push@ethinking.de</a
            >
            <br />
            <span>Web: </span>
            <a href="https://ethinking.de/push" target="_blank" rel="noopener"
              >https://ethinking.de/push</a
            >
          </p>
          <p>
            In the meantime, feel free to explore our
            <a
              href="https://docs.ethinking.de/docs/3.2/index.html"
              target="_blank"
              rel="noopener noreferrer"
              >documentation
            </a>
            to get started.
          </p>
        </ng-container>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row">
  <div class="col-12 col-lg-6">
    <nb-card accent="primary">
      <nb-card-header>{{ "getting_started" | translate }}</nb-card-header>
      <nb-card-body>
        <nb-actions size="medium" class="mt-2">
          <nb-action icon="grid-outline"></nb-action>
          <nb-action>
            {{ "create_a_new_app" | translate }}
          </nb-action>
          <nb-action class="ml-auto">
            <a
              [routerLink]="'/' + ($clientId | async) + '/apps'"
              style="width: 150px"
            >
              <button nbButton fullWidth status="primary">
                {{ "create_app" | translate }}
              </button>
            </a>
          </nb-action>
        </nb-actions>

        <nb-actions size="medium" class="mt-4">
          <nb-action icon="pricetags-outline"></nb-action>
          <nb-action>
            {{ "create_a_new_tag" | translate }}
          </nb-action>
          <nb-action class="ml-auto">
            <a
              [routerLink]="'/' + ($clientId | async) + '/tags'"
              style="width: 150px"
            >
              <button nbButton fullWidth status="primary">
                {{ "create_tag" | translate }}
              </button>
            </a>
          </nb-action>
        </nb-actions>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-12 col-lg-6">
    <nb-card accent="primary">
      <nb-card-header>{{ "need_help" | translate }}</nb-card-header>
      <nb-card-body>
        <nb-actions size="medium" class="mt-2">
          <nb-action icon="book-open-outline"></nb-action>
          <nb-action>
            {{ "documentation" | translate }}
          </nb-action>
          <nb-action class="ml-auto">
            <a
              href="https://docs.ethinking.de/docs/3.2/index.html"
              target="_blank"
              rel="noopener noreferrer"
              style="width: 150px"
            >
              <button nbButton fullWidth status="primary">
                {{ "open" | translate }}
              </button>
            </a>
          </nb-action>
        </nb-actions>

        <nb-actions size="medium" class="d-flex mt-4">
          <nb-action icon="at-outline"></nb-action>
          <nb-action>
            {{ "get_in_touch" | translate }}
          </nb-action>
          <nb-action class="ml-auto">
            <a
              href="mailto:push@ethinking.de?subject=Question%20from%20ethinking.push"
              style="width: 150px"
            >
              <button nbButton fullWidth status="primary">
                {{ "contact" | translate }}
              </button>
            </a>
          </nb-action>
        </nb-actions>
      </nb-card-body>
    </nb-card>
  </div>
</div>
